import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import useAppState, { SettingsTab } from '@/hooks/useAppState';

import LoadingAnimation from './LoadingAnimation';

/**
 * Component that redirects to the settings page with the integrations tab selected.
 * This allows users to navigate directly to /integrations and be taken to the
 * integrations section of the settings page.
 */
export default function IntegrationsRedirect() {
  const { selectSettingsTab, settingsTab } = useAppState();

  useEffect(() => {
    if (settingsTab !== SettingsTab.INTEGRATIONS) {
      selectSettingsTab(SettingsTab.INTEGRATIONS);
    }
  }, [selectSettingsTab, settingsTab]);

  // Only redirect after the tab is set to INTEGRATIONS
  if (settingsTab !== SettingsTab.INTEGRATIONS) {
    return (
      <div
        className="flex flex-col items-center justify-center h-64"
        role="status"
        aria-live="polite"
      >
        <LoadingAnimation className="w-16 h-16 mb-2" />
        <span className="text-sm text-gray-600">
          Redirecting to Integrations…
        </span>
      </div>
    );
  }
  return <Navigate to="/settings" replace />;
}
